import { ALL, CAMPAIGN_MENU_WORDING, campaignLabel, setCurrentCampaign, useCampaign } from '@lib/campaigns';

/**
 * ROW 354: what a campaign selection is doing to the list on screen, SAID. Nothing when All is chosen.
 * `others` is how many rows on this list the selection is setting aside (rows naming ANOTHER
 * campaign; a row naming none is never set aside), with one click back to every campaign.
 */
export function CampaignScopeNote({ others }: { others: number }): JSX.Element | null {
  const sel = useCampaign();
  if (sel === ALL) return null;
  return (
    <div className="note micro" role="status" style={{ marginBottom: 8, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
      <span>{CAMPAIGN_MENU_WORDING.scoped(campaignLabel(sel), others)}</span>
      <button type="button" className="btn btn-sm btn-ghost" onClick={() => setCurrentCampaign(ALL)}>{CAMPAIGN_MENU_WORDING.showAll}</button>
    </div>
  );
}

/** For a screen whose rows carry no campaign yet (Lookup, Archive): it says so rather than pretend. */
export function NotByCampaignNote({ screen }: { screen: string }): JSX.Element | null {
  const sel = useCampaign();
  if (sel === ALL) return null;
  return <div className="note micro" role="status" style={{ marginBottom: 8 }}>{CAMPAIGN_MENU_WORDING.notByCampaign(screen)}</div>;
}
